<template>
    <div class="container">
      <b-card tag="article" class="mb-2">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label
                for="oneripersonale"
                class="h5"
            >Seleziona file xlsx: </label>
              <ejs-uploader ref="oneripersonale" id='oneripersonale' name="oneripersonale" :asyncSettings="path"
                            :removing="addJWTHeaders" :autoUpload="false" :multiple="multiplo"
                            :uploading="onFileUpload" :success="afterUpload" :failure="uploadError"
              ></ejs-uploader>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 text-right mt-1" v-show="showDownload">
            <ejs-button id="downloadMinistero" cssClass="e-flat"
              @click.native="downloadMinistero()">Scarica file Ministero</ejs-button>
            <ejs-button id="downloadFileValidato" cssClass="e-flat"
              @click.native="downloadFileValidato()">Scarica file validato</ejs-button>
          </div>
        </div>
        <div class="row">
            <div class="mt-2 col-xs-12 col-sm-12 col-lg-12 col-md-12" v-if="alertErrore">
                  <b-alert show dismissible variant="warning">
                    <h4 class="alert-heading">Errore</h4>
                      <p class="m-2" v-for="m in messaggio">
                              {{ m }}
                      </p>
                  </b-alert>
            </div>
        </div>
      </b-card>
    </div>
</template>
<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'

import { AlertPlugin, CardPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { createElement } from '@syncfusion/ej2-base'

const uploadEle = createElement('span', { className: 'prova' })
uploadEle.innerHTML = ' '
const clearEle = createElement('span', { className: 'remove e-icons' })
clearEle.innerHTML = 'Clear All'

const axios = require("axios");
Vue.use(AlertPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(UploaderPlugin)

export default {
  data() {
    return {
      d: [],
      showDownload: false,
      multiplo: false,
      messaggio: [],
      fileOneriUrl: "",
      fileMinisteroUrl: "",
      fileConsulenteLavoroUrl: "",
      alertErrore: false,
      path: {
        saveUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/bilancioministero/import_oneri`,
      },
      buttons: {
        browse: 'Choose file',
        clear: clearEle,
        upload: uploadEle,
      },
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    onFileUpload(args) {
      console.log("FILEDATA")
      console.log(args.fileData)

      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    afterUpload(args) {
      // console.log(args)
      if (args.name === 'success') {
        console.log('tutto a posto')
        if (args.e.target.response) {

          const risposta = JSON.parse(args.e.target.response)
          //const imgUrl = args.e.target.response.replace(/"/g, ""); // rimuovi apici dalla risposta ottenuta dal backend
          console.log(risposta['filePersonaleMinistero'])
          this.fileMinisteroUrl = risposta['filePersonaleMinistero']
          console.log(risposta['fileConsulenteLavoro'])
          this.fileConsulenteLavoroUrl = risposta['fileConsulenteLavoro']
          this.makeToast('primary', 'Info', 'Import eseguito correttamente')
          // SEGNA TUTTO OK PER ABILITARE DOWNLOAD
          this.showDownload = true
          // const risposta = JSON.parse(args.e.target.response)
          // console.log(risposta['fileOneri'])
          // this.fileOneriUrl = risposta['fileOneri']
          // // SEGNA TUTTO OK PER ABILITARE DOWNLOAD
          // this.showDownload = true
          // this.makeToast('primary', 'Info', 'Import eseguito, alcune righe non importate')
        } else {
          this.makeToast('primary', 'Info', 'Import eseguito correttamente')
        }
      }
    },
    downloadMinistero() {
      const url = this.fileMinisteroUrl;
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", "file_ministero.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    downloadFileValidato() {
      const url = this.fileConsulenteLavoroUrl;
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", "file_consulente_lavoro.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    uploadError(args) {
        //console.log(args)
        let response = JSON.parse(args.e.target.response)
        // console.log(response)
        if (response) {
          response.forEach((k) => {
            if ('errore' in k) {
              this.messaggio.push(k.errore)
            } else {
              for (const [key, value] of Object.entries(k)) {
                this.messaggio.push(`${key}: ${value}`);
              }
            }
            this.alertErrore = true
          })
          // this.makeToast("primary", "ERRORE", messaggio);
        }
        // TODO: gestione errore con download report
    },
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
